export const getParams = (userID: number, accountID: number) =>
  `userID=${userID}&account=${accountID}`;
